import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { segExonerado } from "../config/constantes";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import { update_paso } from "../services/procesoMatricula/procesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const ModalError = () => {
   
  let { obtenerDatosEstudiante, gruposHabilitados } = useMatricula();
  let {
    setLoading,
    setPasoProcesoM,
    setPasoSegundaVistaProcesoM,
    errorServices,
    setErrorServices,
    errorCursoServices
  } = useProcesoMatricula();
  


  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  useEffect(() => {
    
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        lbl_pago_msj_exonerado: obtenerLabelEtiqueta(
          "lbl_pago_msj_exonerado",
          listadoEtiquetas
        ),
        lbl_pago_msj_sistema: obtenerLabelEtiqueta(
          "lbl_pago_msj_sistema",
          listadoEtiquetas
        ),
        lbl_pago_segundos: obtenerLabelEtiqueta(
          "lbl_pago_segundos",
          listadoEtiquetas
        ),
        lbl_update_datos_continuar: obtenerLabelEtiqueta(
          "lbl_update_datos_continuar",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const {
    lbl_pago_msj_exonerado,
    lbl_update_datos_continuar,
    lbl_pago_segundos,
    lbl_pago_msj_sistema,
  } = etiquetas;

   
  return (
    <div
      className="modal fade"
      id="error"
      tabIndex={-1}
      data-bs-backdrop="static" 
      data-bs-keyboard="false"
      aria-labelledby="exampleModalLabel1" 
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-bottom-0 d-none">
            <h5 className="modal-title" id="exampleModalLabel1" />
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body pb-0 pt-4">
            <div className="text-center mt-3">
              <h5 className="text-uppercase mb-3">Ocurrió un error inesperado</h5>
              
              <p>
                {errorCursoServices}
              </p>
             
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
            
              data-bs-dismiss="modal"
              aria-label="Close"
              id="cerrarError"
            >
              {lbl_update_datos_continuar}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalError;
